import { Section } from "../../components/Section/Section";
import { ZitateSliderOptionsType } from "@/types/ModuleOptionsType";
import { ZitatSlider } from "./QuoteSlider/QuoteSlider";
import { Modul_Zitat_Slider } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { EndCardsType } from "@/types/OptionType";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { columnSize } from "@/utils/layout/columnSize";
import { Headline } from "@/components/Headline/Headline";
import { FadeInUp } from "@/components/Animation/ScrollAnimation";
import { ImageType, LinkType } from "@/types/baseTypes";
import styles from "./QuoteSliderModule.module.scss";

export type QuotesElementType = {
  title: string;
  content_size: "small" | "big";
  content: string;
  name: string;
  firstname: string;
  position: string;
  firma: string;
  image: ImageType | false;
  rating_stars: number;
  source: {
    type: "logo" | "text";
    logo: ImageType | false;
    text: string;
  };
  link: LinkType | false;
};

export type QuoteSliderModuleModuleType = Modul_Zitat_Slider;
interface QuoteSliderModuleProps {
  data: QuoteSliderModuleModuleType;
  quotesSliderOptions: ZitateSliderOptionsType;
  quotesSliderData: QuotesElementType[];
  index: number;
  endCardData: EndCardsType | undefined;
}
{
  /* jscpd:ignore-start */
}
const QuoteSliderModule = ({
  data,
  quotesSliderOptions,
  quotesSliderData,
  index,
  endCardData,
}: QuoteSliderModuleProps) => {
  const {
    show_avatar: showAvatar,
    show_rating: showRating,
    section_padding_class,
    section_margin_class,
    background_color_class,
    headline_text_align_class,
    id,
    module_width,
  } = data.layout;

  const { headline, headline_html_tag, subline, overline } =
    data.quotes_slider || {};

  const { show_overline_subline, columns } = quotesSliderOptions || {};

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }

  const SliderJSX = (
    <ZitatSlider
      headlineTag={headline_html_tag}
      elements={quotesSliderData}
      quotesSliderOptions={quotesSliderOptions}
      showAvatar={showAvatar}
      showRating={showRating}
      moduleIndex={index}
      endCardData={endCardData}
      heading_level={headline ? 3 : 2}
    />
  );

  return (
    <Section
      id={id}
      className={`quote-slider ${styles["quote-slider-mod"]} ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      columnsClassName="is-centered is-multiline"
      frameless={module_width === "frameless"}
    >
      <div
        className={`column ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
      >
        {headline && headline_html_tag && (
          <FadeInUp>
            <Headline
              headline_html_tag={headline_html_tag}
              headline={headline}
              overline={showOverline ? overline : ""}
              subline={showSubline ? subline : ""}
              extraClass={headline_text_align_class}
              wrapInSection={module_width === "frameless"}
              disableAnimation
            />
          </FadeInUp>
        )}
        <FadeInUp>{SliderJSX}</FadeInUp>
      </div>
    </Section>
  );
};

export default QuoteSliderModule;
{
  /* jscpd:ignore-end */
}
